import { Box, FlexLayout, H2 } from '@deity/falcon-ui';
import type { IPropertyBag } from '@deity-io/di-data-basics';
import { mapRecord } from '@deity-io/di-data-basics';
import { TRow, TableView } from 'components';
import { toLocalDateString } from 'contracts/constants';
import { useRef } from 'react';
import type { FC } from 'react';
import type { IRuntimeState } from '../IRuntimeState';
import { filterServiceType } from '../IRuntimeState';

type PackagePopoutExternalProps = {
  component: {
    method: string;
    path: string;
    instances: Record<string, IPropertyBag>;
    instanceCount: number;
    since: number;
    last: number;
    count: number;
  };
  componentKey: string;
  flowKey?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  pipelineKey: string;
  accountUuid: string;
  packageVersionUuid: string;
  services: IRuntimeState['services'];
};

export const PackagePopoutExternal: FC<PackagePopoutExternalProps> = ({ component, componentKey, services }) => {
  let serviceType: string | undefined;
  mapRecord(component.instances, (instance, instanceKey) => {
    serviceType = filterServiceType(services, instanceKey);
  });

  const svgWrapperRef = useRef<HTMLDivElement | null>(null);

  if (svgWrapperRef.current) {
    svgWrapperRef.current.innerHTML = /* comp?.icon || */ '';
  }

  return (
    <FlexLayout
      flexDirection="column"
      border="regular"
      css={{ padding: '5px', margin: '5px', borderRadius: '15px', minHeight: '50px', minWidth: '50px' }}
    >
      <FlexLayout flexDirection="row" width="full" justifyContent="center">
        <Box ref={svgWrapperRef} css={{ paddingRight: '10px' }} />
        <H2>{componentKey}</H2>
      </FlexLayout>
      <TableView gridTemplateColumns="0.5fr 1fr">
        <TRow rowHeight="40px">
          <>
            <Box>Path</Box>
            <Box alignContent="right" width="full">
              {component.method} {component.path}
            </Box>
          </>
        </TRow>
        <TRow rowHeight="40px">
          <>
            <Box>Instances</Box>
            <Box>
              {component.instanceCount}/{component.instanceCount}
              {serviceType && ` ${serviceType}`}
            </Box>
          </>
        </TRow>
        <TRow rowHeight="40px">
          <>
            <Box>Messages</Box>
            <Box alignContent="right" width="full">
              {component.count}
            </Box>
          </>
        </TRow>
        <TRow rowHeight="40px">
          <>
            <Box>Since</Box>
            <Box>{toLocalDateString(component.since || '')}</Box>
          </>
        </TRow>
        {component.last ? (
          <TRow rowHeight="40px">
            <>
              <Box>Last</Box>
              <Box>{toLocalDateString(component.last || '')}</Box>
            </>
          </TRow>
        ) : null}
      </TableView>
    </FlexLayout>
  );
};
